import React, { PureComponent } from 'react';
import { Row, Col, Form, FormGroup, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { isURL } from 'validator';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { bool, array, object, func } from 'prop-types';
import Card from '../../../../components/Card/Card';
import { startSetFaqPage } from '../../../../actions/faq';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import FlowPostbackMethod from '../../components/Postback/FlowPostbackMethod';
import FlowPostbackUrl from '../../../../components/Flow/FlowPostbackUrl';
import FlowPostbackStatuses from '../../../../components/Flow/FlowPostbackStatuses';
import Hint from '../../../../components/Hint/Hint';
import GlobalPostbackPresets from './GlobalPostbackPresets';
import { createMarkup } from '../../../../utils/utils';

const GLOBAL_USAGE_STATUS = 5;

class GlobalPostbackForm extends PureComponent {
  static propTypes = {
    statuses: array.isRequired,
    enabled: bool,
    loading: bool,
    postback: object,
    onCheckPostback: func.isRequired,
    onSubmit: func.isRequired,
  };

  static defaultProps = {
    statuses: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      enabled: true,
      data: {
        method: 0,
        url: '',
        statuses: [],
      },
    };
  }

  componentDidMount() {
    this.props.startSetFaqPage(183);
  }

  UNSAFE_componentWillReceiveProps({ loading, postback }) {
    if (!loading && postback && postback.url) {
      this.setState(prevState => ({
        enabled: !!postback.status,
        data: {
          ...prevState.data,
          method: postback.method,
          url: postback.url,
          statuses: postback['pixels_status'] || postback['pixels_status[]'] || [],
        },
      }));
    }
  }

  handleChange = data => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        ...data,
      },
    }));
  };

  onStatusChange = statuses => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        statuses,
      },
    }));
  };

  togglePostback = ({ target }) => {
    this.setState(() => ({ enabled: target.checked }));
  };

  toggleGlobalUsage = () => {
    const { statuses } = this.state.data;
    const index = statuses.indexOf(GLOBAL_USAGE_STATUS);
    const updatedStatuses = [];

    if (index === -1) {
      updatedStatuses.push(GLOBAL_USAGE_STATUS);
      updatedStatuses.push(...this.selectAllStatuses());
    } else {
      statuses.splice(index, 1);
      updatedStatuses.push(...statuses);
    }

    this.onStatusChange(updatedStatuses);
  };

  isValid = url => url === '' || isURL(url, { require_protocol: true });

  handleSubmit = e => {
    e.preventDefault();

    if (this.state.enabled) {
      const { url = '', method = 0, statuses = [] } = this.state.data;

      this.props.onSubmit({
        status: 1,
        url,
        method,
        'pixels_status[]': statuses,
      });
    } else {
      this.props.onSubmit({ status: 0 });
    }
  };

  onPresetApply = url => {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        url,
      },
    }));
  };

  selectAllStatuses = () => this.props.statuses.map(status => status.id);

  getFaq = page => {
    if (page && page.page) {
      return page.page.substring(
        page.page.indexOf('<p>Настройка <strong>PostBack</strong>'),
        page.page.indexOf('<h3>Доступные параметры</h3>'),
      );
    }
  };
  getFaqParamsInfo = page => {
    if (page && page.page) {
      return page.page.substring(page.page.indexOf('<h3>Доступные параметры</h3>'));
    }
  };
  getFaqParamsExampleLink = page => {
    if (page && page.page) {
      return `<p class='link-example'>${page.page.substring(
        page.page.indexOf('Пример ссылки'),
        page.page.indexOf('<p>Настройка'),
      )}</p>`;
    }
  };

  render() {
    const { enabled, data } = this.state;
    const {
      loading,
      statuses,
      theme,
      faq: { page },
    } = this.props;
    const globalUsageEnabled = data.statuses.indexOf(GLOBAL_USAGE_STATUS) !== -1;

    return (
      <Form className="global-postback-form" onSubmit={this.handleSubmit}>
        <Card loading={loading}>
          <Card.Header className="title-lg">
            <FormattedMessage id="postback.global.title" defaultMessage="Global Postback" />
          </Card.Header>
          <Card.Body>
            <Row>
              <Col lg="6" className="mb-3 global-postback-faq-preview">
                {page && page.page && (
                  <div dangerouslySetInnerHTML={createMarkup(this.getFaq(page))} />
                )}
                {/* <FormGroup className="postback-enable">
              <CustomControl
                id="global-postback"
                className="custom-control-xs no-margin"
                label={
                  <FormattedMessage
                    id="postback.global.enable"
                    defaultMessage="Enable global postback"
                  />
                }
                value="1"
                onChange={this.togglePostback}
                checked={enabled}
                inline
              />

              <Hint id="global-postback-hint" placement="right" delay={250}>
                <FormattedHTMLMessage
                  id="postback.global.hint-1"
                  defaultMessage="A&nbsp;global postback is&nbsp;an&nbsp;additional parameter, which lets you
                  collecting information about every conversion you&rsquo;ve made and aggregate your
                  very own statistics via self-hosted statistics systems or&nbsp;third-party
                  trackers."
                  tagName="p"
                />
                <FormattedHTMLMessage
                  id="postback.global.hint-2"
                  defaultMessage="When our statistics tracks a&nbsp;conversion, the system will send GET
                  or&nbsp;POST request to&nbsp;the url you specified in&nbsp;&laquo;Postback
                  URL&raquo; parameter."
                  tagName="p"
                />
              </Hint>
            </FormGroup> */}
                <Col xl="6" className="p-0">
                  <GlobalPostbackPresets onPresetApply={this.onPresetApply} />
                </Col>

                <fieldset>
                  <Col xl="6" className="p-0">
                    <FlowPostbackUrl
                      theme={4}
                      url={data.url}
                      onUrlChange={this.handleChange}
                      onCheckPostback={() => this.props.onCheckPostback(data)}
                    />
                    <FlowPostbackStatuses
                      statuses={statuses}
                      selected={data.statuses}
                      onStatusChange={this.onStatusChange}
                    />
                  </Col>

                  <div className="mt-3 postback-extra-settings">
                    <Row>
                      {/* <Col lg="4" xl="3">
                    <CustomControl
                      id="global-usage"
                      className="custom-control-xs no-margin"
                      label={
                        <FormattedMessage
                          id="postback.global.use-for-all"
                          defaultMessage="Use for all flows"
                        />
                      }
                      value="1"
                      onChange={this.toggleGlobalUsage}
                      checked={globalUsageEnabled}
                      inline
                    />

                    <Hint id="global-postback-usage" placement="right" delay={250}>
                      <FormattedMessage
                        id="postback.global.use-for-all.hint"
                        defaultMessage="The global postback will be working on every flow you created, disabling
                          settings of postback you specified in the flow before"
                      />
                    </Hint>
                  </Col> */}

                      <Col lg="8" xl="9">
                        <FlowPostbackMethod
                          method={data.method}
                          onPostbackMethodChange={this.handleChange}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12">
                        <Button
                          className="mr-3"
                          size="sm"
                          color="primary"
                          disabled={loading || !this.isValid(data.url)}
                        >
                          <FormattedMessage id="main.save" defaultMessage="Save" />
                        </Button>
                        <Button
                          size="sm"
                          type="button"
                          color="secondary"
                          onClick={() => this.props.onCheckPostback(data)}
                          disabled={!isURL(data.url)}
                        >
                          <FormattedMessage
                            id="flow.form.postback.check"
                            defaultMessage="Check Postback"
                          />
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </fieldset>
              </Col>
              <Col lg="6" className="postback-faq-params">
                {page && page.page && (
                  <div
                    className="postback-faq-params-wrapper"
                    dangerouslySetInnerHTML={{
                      __html: this.getFaqParamsExampleLink(page) + this.getFaqParamsInfo(page),
                    }}
                  />
                )}
              </Col>
            </Row>
          </Card.Body>

          {/* <Card.Footer>

            <ul className="postback-links list-inline no-margin">
              {theme !== 3 && (<li className="list-inline-item">
                <Link to="/tools/global-postback/logs">
                  <FormattedMessage id="flow.form.postback.logs" defaultMessage="Logs" />
                </Link>
              </li>)}
              <li>
                <Button
                  size="sm"
                  color="primary"
                  disabled={loading || !this.isValid(data.url)}
                >
                  <FormattedMessage id="main.save" defaultMessage="Save" />
                </Button>
              </li>
            </ul>

          </Card.Footer> */}
        </Card>

        {/* <Row>
          <Col>
            <FormGroup>
              <Button
                className="btn-lead"
                size="lg"
                color="primary"
                disabled={loading || !this.isValid(data.url)}
              >
                <FormattedMessage id="main.save" defaultMessage="Save" />
              </Button>
            </FormGroup>
          </Col>
        </Row> */}
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  faq: state.faq,
});
const mapDispatchToProps = dispatch => ({
  startSetFaqPage: faqId => dispatch(startSetFaqPage(faqId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalPostbackForm);
